<template>
	<div class="o-carSingle__formApp">
		<router-view />
	</div>
</template>

<script setup>
</script>

